// 员工端
const routers = 
[
  {
    path: "/staff",
    component: resolve =>
      require(["@/components/staff/index/layout"], resolve),
    children: [
      {
        path: "/staff",
        name: "Index",
        component: resolve => require(["@/pages/staff/index/index"], resolve),
        meta: { title: "首页" }
      },
      {
        path: "/workbench",
        name: "Workbench",
        component: resolve =>
          require(["@/pages/staff/workbench/index"], resolve),
        meta: { title: "工作台" }
      },
      {
        path: "/user",
        name: "User",
        component: resolve => require(["@/pages/staff/user/index"], resolve),
        meta: { title: "人员" }
      },
      {
        path: "/my",
        name: "My",
        component: resolve => require(["@/pages/staff/my/index"], resolve),
        meta: { title: "我的" }
      }
    ]
  },
  {
    path: "/staff/company",
    name: "staffCompany",
    component: resolve => require(["@/pages/staff/index/company"], resolve),
    meta: { title: "切换公司" }
  },
  // 消息
  {
    path: "/message/detail/:type",
    component: resolve =>
      require(["@/pages/staff/index/message/index"], resolve),
    meta: { title: "消息" }
  },
  {
    path: "/message/user/:uid",
    component: resolve =>
      require(["@/pages/staff/index/message/children/user"], resolve),
    meta: { title: "消息" }
  },
  // 岗位值
  {
    path: "/station",
    component: resolve =>
      require(["@/pages/staff/station/components/layout"], resolve),
    children: [
      {
        path: "/station",
        component: resolve =>
          require(["@/pages/staff/station/index/index"], resolve),
        meta: { title: "岗位" }
      },
      {
        path: "/station/all",
        component: resolve =>
          require(["@/pages/staff/station/station/index"], resolve),
        meta: { title: "岗位" }
      },
      {
        path: "/station/look",
        component: resolve =>
          require(["@/pages/staff/station/look/index"], resolve),
        meta: { title: "公示" }
      }
    ]
  },
  {
    path: "/station/user-station",
    component: resolve =>
      require(["@/pages/staff/station/look/userStation/index"], resolve),
    meta: { title: "用户岗位" }
  },
  { 
    path: "/pk",
    component: resolve => 
      require(["@/pages/staff/pk/components/layout"], resolve),
    meta: { title: "PK" },
    children: [
      {
        path: "/pk",
        component: resolve => require(["@/pages/staff/pk/pk"], resolve),
        meta: { title: "PK" }
      },
      {
        path: "/pk/statistics",
        component: resolve =>
          require(["@/pages/staff/pk/statistics"], resolve),
        meta: { title: "PK统计" }
      }
    ]
  },
  // 公告
  {
    path: "/notice/list",
    component: resolve => require(["@/pages/staff/notice/list"], resolve),
    meta: { title: "公告列表" }
  },
  {
    path: "/notice/detail/:id",
    component: resolve => require(["@/pages/staff/notice/detail"], resolve),
    meta: { title: "公告详情" }
  },
  // 行为值
  {
    path: "/behavior",
    component: resolve =>
      require(["@/pages/staff/behavior/components/layout"], resolve),
    children: [
      {
        path: "/behavior",
        component: resolve =>
          require(["@/pages/staff/behavior/index"], resolve),
        meta: { title: "我的行为" }
      },
      {
        path: "/behavior/look",
        component: resolve =>
          require(["@/pages/staff/behavior/look"], resolve),
        meta: { title: "行为公示" }
      },
      {
        path: "/behavior/plan",
        component: resolve =>
          require(["@/pages/staff/behavior/plan"], resolve),
        meta: { title: "行为设置" }
      },
      {
        path: "/behavior/rank",
        component: resolve =>
          require(["@/pages/staff/behavior/rank"], resolve),
        meta: { title: "行为排名" }
      }
    ]
  },
  {
    path: "/behavior/set",
    component: resolve => require(["@/pages/staff/behavior/set"], resolve),
    meta: { title: "我的行为" }
  },
  {
    path: "/behavior/user/:uid/:month",
    component: resolve => require(["@/pages/staff/behavior/children/userBehavior"], resolve),
    meta: { title: "用户行为" }
  },
  {
    path: "/behavior/log/:plan_id",
    component: resolve => require(["@/pages/staff/behavior/children/log"], resolve),
    meta: { title: "行为记录" }
  },
  {
    path: "/behavior/likes",
    component: resolve => require(["@/pages/staff/behavior/children/likes"], resolve),
    meta: { title: "点赞" }
  },
  {
    path: "/behavior/item/:behaviorId",
    component: resolve => require(["@/pages/staff/behavior/children/behaviorItem"], resolve),
    meta: { title: "行为详情" }
  },
  {
    path: "/behavior/analysis",
    component: resolve => require(["@/pages/staff/behavior/children/behaviorAnalysis"], resolve),
    meta: { title: "行为分析" }
  },
  // 任务
  {
    path: "/task/list",
    component: resolve =>
      require(["@/pages/staff/task/components/layout"], resolve),
    children: [
      {
        path: "/task/list",
        component: resolve => require(["@/pages/staff/task/list"], resolve),
        meta: { title: "任务列表" }
      },
      {
        path: "/task/release",
        component: resolve =>
          require(["@/pages/staff/task/release"], resolve),
        meta: { title: "任务发布" }
      }
    ]
  },
  {
    path: "/task/receive/:task_id",
    component: resolve => require(["@/pages/staff/task/receive"], resolve),
    meta: { title: "任务详情" }
  },
  // 共享值
  {
    path: "/finance",
    component: resolve =>
      require(["@/pages/staff/finance/components/layout"], resolve),
    children: [
      {
        path: "/finance",
        component: resolve =>
          require(["@/pages/staff/finance/index"], resolve),
        meta: { title: "共享值" }
      }
    ]
  },
  // 费用详情
  {
    path: "/finance/detail",
    component: resolve =>
      require(["@/pages/staff/finance/children/detail"], resolve),
    meta: { title: "" }
  },
  // 月份费用详情
  {
    path: "/finance/month/:month",
    component: resolve =>
      require(["@/pages/staff/finance/children/month-detail"], resolve),
    meta: { title: "345" }
  },
  // 记录详情
  {
    path: "/finance/log",
    component: resolve =>
      require(["@/pages/staff/finance/children/log"], resolve),
    meta: { title: "详情" }
  },
  {
    path: "/weekly/list",
    component: resolve =>
      require(["@/pages/staff/weekWork/components/layout"], resolve),
    children: [
      {
        path: "/weekly/list",
        component: resolve =>
          require(["@/pages/staff/weekWork/list"], resolve),
        meta: { title: "我的周报" }
      },
      {
        path: "/weekly/report",
        component: resolve =>
          require(["@/pages/staff/weekWork/report-list"], resolve),
        meta: { title: "汇报列表" }
      }
    ]
  },
  {
    path: "/weekly/write",
    component: resolve => require(["@/pages/staff/weekWork/write"], resolve),
    meta: { title: "填写周报" }
  },
  {
    path: "/weekly/detail",
    component: resolve => require(["@/pages/staff/weekWork/detail"], resolve),
    meta: { title: "详情" }
  },
  // 排班
  {
    path: "/scheduling",
    component: resolve =>
      require(["@/pages/staff/scheduling/index"], resolve),
    meta: { title: "我的排班" }
  },
  // 报餐
  {
    path: "/meals/index",
    component: resolve =>
      require(["@/pages/staff/meals/components/layout"], resolve),
    children: [
      {
        path: "/meals/index",
        component: resolve => require(["@/pages/staff/meals/index"], resolve),
        meta: { title: "报餐" }
      },
      {
        path: "/meals/menu",
        component: resolve => require(["@/pages/staff/meals/menu"], resolve),
        meta: { title: "菜单" }
      },
      {
        path: "/meals/satisfaction",
        component: resolve => require(["@/pages/staff/meals/satisfaction"], resolve),
        meta: { title: "菜单" }
      }
    ]
  },
  {
    path: "/meals/add",
    component: resolve => require(["@/pages/staff/meals/add"], resolve),
    meta: { title: "菜单" }
  },
  {
    path: "/satisfaction",
    component: resolve =>
      require(["@/pages/staff/satisfaction/index"], resolve),
    meta: { title: "满意度" }
  },
  {
    path: "/satisfaction/superior/:message_id",
    component: resolve =>
      require(["@/pages/staff/satisfaction/detail/superior"], resolve),
    meta: { title: "上级评价" }
  },
  {
    path: "/satisfaction/user/:satisfaction_number/:message_id",
    component: resolve =>
      require(["@/pages/staff/satisfaction/detail/user"], resolve),
    meta: { title: "个人问卷" }
  },
  {
    path: "/satisfaction/user-detail/:id",
    component: resolve =>
      require(["@/pages/staff/satisfaction/detail/user-detail"], resolve),
    meta: { title: "详情" }
  },
  {
    path: "/satisfaction/detail/:id/:category",
    component: resolve =>
      require(["@/pages/staff/satisfaction/detail"], resolve),
    meta: { title: "问卷详情" }
  },
  {
    path: "/my/user-info",
    component: resolve =>
      require(["@/pages/staff/my/children/user-info"], resolve),
    meta: { title: "用户信息" }
  },
  {
    path: "/my/password",
    component: resolve =>
      require(["@/pages/staff/my/children/password"], resolve),
    meta: { title: "修改密码" }
  },
  // 库存管理
  {
    path: "/store",
    component: resolve =>
      require(["@/pages/staff/store/components/layout"], resolve),
    children: [
      {
        path: "/store",
        component: resolve => require(["@/pages/staff/store/index"], resolve),
        meta: { title: "库存管理" }
      },
      {
        path: "/store/receive",
        component: resolve =>
          require(["@/pages/staff/store/receive"], resolve),
        meta: { title: "领取" }
      },
      {
        path: "/store/purchase",
        component: resolve =>
          require(["@/pages/staff/store/purchase"], resolve),
        meta: { title: "采购列表" }
      },
      {
        path: "/store/manage",
        component: resolve =>
          require(["@/pages/staff/store/manage"], resolve),
        meta: { title: "仓库管理" }
      }
    ]
  },
  {
    path: "/store/purchase/apply",
    component: resolve =>
      require(["@/pages/staff/store/purchase/apply"], resolve),
    meta: { title: "申请采购" }
  },
  {
    path: "/store/purchase/detail/:purchaseNumber",
    component: resolve =>
      require(["@/pages/staff/store/purchase/detail"], resolve),
    meta: { title: "采购详情" }
  },
  {
    path: "/store/list",
    component: resolve =>
      require(["@/pages/staff/store/children/store-list"], resolve),
    meta: { title: "仓库物品" }
  },
  // {
  //   path: "/elderly",
  //   component: resolve =>
  //     require(["@/pages/staff/elderly/components/layout.vue"], resolve),
  //   redirect: "/elderly/shift-handover",
  //   children: [
  //     {
  //       path: "/elderly/shift-handover",
  //       component: resolve =>
  //         require(["@/pages/staff/elderly/shift-handover"], resolve),
  //       meta: { title: "沟通重点" }
  //     },
  //     {
  //       path: "/elderly/image",
  //       component: resolve =>
  //         require(["@/pages/staff/elderly/image-list"], resolve),
  //       meta: { title: "每日靓照" }
  //     },
  //     {
  //       path: "/elderly/patrol",
  //       component: resolve =>
  //         require(["@/pages/staff/elderly/patrol"], resolve),
  //       meta: { title: "每日巡视" }
  //     },
  //     {
  //       path: "/elderly/detail/:elderlyId",
  //       component: resolve =>
  //         require(["@/pages/staff/elderly/elderly-detail"], resolve),
  //       meta: { title: "长者信息" }
  //     },
  //     {
  //       path: "/elderly/medical",
  //       component: resolve =>
  //         require(["@/pages/staff/elderly/medical"], resolve),
  //       meta: { title: "每日用药" }
  //     },
  //     {
  //       path: "/elderly/clothing",
  //       component: resolve =>
  //         require(["@/pages/staff/elderly/clothing"], resolve),
  //       meta: { title: "衣物清洗" }
  //     },
  //   ]
  // },
  // 长者沟通重点审核
  {
    path: "/elderly/examine-shift-handover",
    component: resolve =>
      require(["@/pages/staff/elderly/examine-shift-handover"], resolve),
    meta: { title: "沟通重点" }
  },
  {
    path: "/trip",
    component: resolve => require(["@/pages/staff/trip/components/layout"], resolve),
    meta: { title: "我的问卷" },
    children: [
      {
        path: '/trip/apply',
        component: resolve => require(["@/pages/staff/trip/apply"], resolve),
        meta: { title: '出差申请' }
      },
      {
        path: '/trip',
        component: resolve => require(["@/pages/staff/trip/index"], resolve),
        meta: { title: '审批中心' }
      }
    ]
  },
  {
    path: '/trip/detail/:id',
    component: resolve => require(["@/pages/staff/trip/detail"], resolve),
    meta: { title: '出差详情' }
  },
  {
    path: "/consult",
    component: resolve => require(["@/pages/staff/consult/components/layout"], resolve),
    meta: { title: "咨询" },
    children: [
      {
        path: '/consult',
        component: resolve => require(["@/pages/staff/consult/index"], resolve),
        meta: { title: '客户咨询' }
      },
      {
        path: '/consult/list',
        component: resolve => require(["@/pages/staff/consult/list"], resolve),
        meta: { title: '客户列表' }
      }
    ]
  },
  {
    path: '/consult/edit/:id',
    component: resolve => require(["@/pages/staff/consult/edit"], resolve),
    meta: { title: '咨询详情' }
  },
  {
    path: '/assets/inventory',
    component: resolve => require(["@/pages/external/assets/inventory"], resolve),
    meta: { title: '资产盘点' }
  },
  // {
  //   path: "/assets/detail",
  //   component: resolve => require(["@/pages/external/assets/components/layout"], resolve),
  //   meta: { title: "固定资产" },
  //   children: [
  //     {
  //       path: '/assets/detail',
  //       component: resolve => require(["@/pages/external/assets/detail"], resolve),
  //       meta: { title: '资产详情' }
  //     },
  //     {
  //       path: '/assets/inventory',
  //       component: resolve => require(["@/pages/external/assets/inventory"], resolve),
  //       meta: { title: '资产盘点' }
  //     },
  //   ]
  // },
  // 时光录
  {
    path: "/elderly-time-record/:tenant/:number",
    component: resolve => require(["@/pages/external/timeRecode/index"], resolve),
    meta: { title: "时光录" }
  },
  // {
  //   path: "/teach",
  //   component: resolve => require(["@/pages/staff/teach/index"], resolve),
  //   meta: { title: "带教" },
  // },
  {
    path: "/teach/study",
    component: resolve => require(["@/pages/staff/teach/components/layout"], resolve),
    meta: { title: "带教" },
    children: [
      {
        path: '/teach/study',
        component: resolve => require(["@/pages/staff/teach/study"], resolve),
        meta: { title: '我的学习' }
      },
      {
        path: '/teach',
        component: resolve => require(["@/pages/staff/teach/teaching/teach"], resolve),
        meta: { title: '我的带教' }
      },
      {
        path: '/student',
        component: resolve => require(["@/pages/staff/teach/teaching/student"], resolve),
        meta: { title: '我的学习' }
      },
      {
        path: '/teach/content',
        component: resolve => require(["@/pages/staff/teach/teaching/content"], resolve),
        meta: { title: '带教内容' }
      },
      {
        path: '/teach/teacher-list',
        component: resolve => require(["@/pages/staff/teach/teaching/children/teacherList"], resolve),
        meta: { title: '老师列表' }
      },
    ]
  },
  {
    path: '/teach/apply',
    component: resolve => require(["@/pages/staff/teach/teaching/children/teachApply"], resolve),
    meta: { title: '带教申请' }
  },
  {
    path: '/teach/satisfaction',
    component: resolve => require(["@/pages/staff/teach/satisfaction"], resolve),
    meta: { title: '实习问卷' }
  },
  
  // v2版照护计划路由
  {
    path: "/nursing",
    component: resolve => require(["@/pages/staff/nursing/components/layout/index"], resolve),
    meta: { title: "照护" },
    children: [
      {
        path: '/nursing',
        component: resolve => require(["@/pages/staff/nursing/statistics"], resolve),
        meta: { title: '今日统计' }
      },
      {
        path: '/nursing/serve',
        component: resolve => require(["@/pages/staff/nursing/serve"], resolve),
        meta: { title: '护理服务' }
      },
      {
        path: '/nursing/serve-detail/:nursing_id',
        component: resolve => require(["@/pages/staff/nursing/serve-detail"], resolve),
        meta: { title: '护理长者' }
      },
      {
        path: '/nursing/target',
        component: resolve => require(["@/pages/staff/nursing/target"], resolve),
        meta: { title: '护理目标' }
      },
      {
        path: '/nursing/target/elderly/:target_id',
        component: resolve => require(["@/pages/staff/nursing/target/elderly"], resolve),
        meta: { title: '跟踪记录' }
      },
      {
        path: '/nursing/shift-handover',
        component: resolve => require(["@/pages/staff/nursing/shift-handover"], resolve),
        meta: { title: '沟通重点' }
      },
      {
        path: '/nursing/medical',
        component: resolve => require(["@/pages/staff/nursing/medical"], resolve),
        meta: { title: '每日用药' }
      },
      ,
      {
        path: '/nursing/medical-detail/:name/:time',
        component: resolve => require(["@/pages/staff/nursing/medical-detail"], resolve),
        meta: { title: '用药详情' }
      },
      {
        path: '/nursing/mood',
        component: resolve => require(["@/pages/staff/nursing/mood"], resolve),
        meta: { title: '每日心情' }
      },
      {
        path: '/nursing/image',
        component: resolve => require(["@/pages/staff/nursing/image"], resolve),
        meta: { title: '每日靓照' }
      },
      {
        path: '/nursing/clothing',
        component: resolve => require(["@/pages/staff/nursing/clothing"], resolve),
        meta: { title: '衣物清洗' }
      },
      {
        path: '/nursing/patrol',
        component: resolve => require(["@/pages/staff/nursing/patrol"], resolve),
        meta: { title: '每日巡视' }
      },
      {
        path: "/nursing/elderly/:elderlyId",
        component: resolve =>
          require(["@/pages/staff/nursing/elderly"], resolve),
        meta: { title: "长者信息" }
      },
    ]
  },
]

export default routers


// WEBPACK FOOTER //
// ./src/router/staff.js